import styled from 'styled-components';
import { LoadingSpinner, UseCurrentLocationIcon } from 'svg';
import { breakpoints, colors } from '../../constants';

const Row = styled.div``;

interface IProps {
    className?: string;
    loading: boolean;
    onClick?(): void;
}

const BaseCurrentLocationButton = ({ className, loading, onClick }: IProps) => (
    <div className={className} onClick={onClick}>
        {loading ? (
            <LoadingSpinner />
        ) : (
            <Row>
                <UseCurrentLocationIcon />
                <span>Gebruik mijn huidige locatie</span>
            </Row>
        )}
    </div>
);

export const CurrentLocationButton = styled(BaseCurrentLocationButton)`
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background-color: ${colors.white};
    color: ${colors.offBlack};
    font-size: 1rem;
    font-weight: 700;
    border: 2px solid ${colors.greyBorder};
    border-radius: 3px;
    transition: all 0.2s ease-in-out;

    &:hover {
        border: 2px solid ${colors.offBlack};
        color: ${colors.greyDark};

        ${UseCurrentLocationIcon} {
            fill: ${colors.greyDark};
        }
    }

    @media (${breakpoints.mediumMin}) {
        max-width: initial;
        width: 100%;
    }

    ${LoadingSpinner} {
        width: 24px;
        height: 24px;
        stroke: ${colors.white};
    }

    ${Row} {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    ${UseCurrentLocationIcon} {
        transition: fill 0.15s linear;
        margin-right: 10px;
        fill: ${colors.offBlack};
    }
`;
